import { Capacitor } from '@capacitor/core'

import type { ServerInfo } from '@healthblocks-io/core'

type HospitalServer = Pick<ServerInfo, 'api' | 'projectId'>

/**
 * Storage in which core's AuthProvider persists a hospital session.
 * Must match the `storage` prop passed to <AuthProvider> in TenantGuard.
 */
export function hospitalSessionStorage(): Storage {
  return Capacitor.isNativePlatform() ? localStorage : sessionStorage
}

/**
 * Key under which core's AuthProvider persists the session of a hospital:
 * `${Project.prefix}/auth`, where the prefix is `${api}/${appKey}/${pid}/`
 * and the patient app passes no app key.
 */
export function hospitalSessionKey(server: HospitalServer) {
  return `${server.api}//${server.projectId}//auth`
}

/**
 * Removes the persisted session of every hospital, so each hospital opens on
 * its login page instead of resuming a session of another profile.
 */
export function clearHospitalSessions(servers: HospitalServer[]) {
  const storage = hospitalSessionStorage()

  for (const server of servers) {
    storage.removeItem(hospitalSessionKey(server))
  }
}
